/*
 * @Author: lbh
 * @Date: 2023-10-31 11:44:37
 * @LastEditors: lbh
 * @LastEditTime: 2023-10-31 12:03:11
 * @Description: file content
 */
let compare = {
  //繁體
  "zh-hk": "hk",
  "zh-hant": "hk",
  "zh-mo": "hk",
  "zh-tw": "hk",
  "zh-sg": "hk",
  // 英文
  "en":"en",
  "en-us": "en",
  // 中文簡體
  "zh-cn": "zh"
};

const _compare = {
  get() {
    let la = navigator.language;
    let _ = compare[la.toLocaleLowerCase()];
    if (_) return _;
    else return "hk";
  }
};

export default _compare;
